var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Type } from "class-transformer";
import { GlobalPatientReference, PatientGuidedConsentDto } from "./patient.dtos";
import { IsBoolean, IsNumber, IsObject, IsOptional, IsString, ValidateNested } from "class-validator";
import { ConsentFlowProgressDto, ConsentStateSearchInput } from "./consent.dtos";
import { IdentifiedPatientDto } from "./recruitment.dtos";
import { StudyDto } from "./study.dtos";
import { PatientConsentsByStudyDto } from "./patient.consent.dtos";
import { ConsentRequestSearchInput } from "./consent.request.dtos";
export class BasicSearchTermInput {
}
__decorate([
    IsString({ each: true }),
    IsOptional()
], BasicSearchTermInput.prototype, "equalsOneOf", void 0);
export class LocationAndDistance {
}
__decorate([
    IsString()
], LocationAndDistance.prototype, "location", void 0);
__decorate([
    IsString()
], LocationAndDistance.prototype, "withinDistance", void 0);
export class LocationSearchTermInput extends BasicSearchTermInput {
}
__decorate([
    Type(() => LocationAndDistance),
    ValidateNested(),
    IsOptional()
], LocationSearchTermInput.prototype, "near", void 0);
export class ComparableSearchTermInput extends BasicSearchTermInput {
}
__decorate([
    IsString(),
    IsOptional()
], ComparableSearchTermInput.prototype, "lessThanOrEqual", void 0);
__decorate([
    IsString(),
    IsOptional()
], ComparableSearchTermInput.prototype, "greaterThanOrEqual", void 0);
export class ConditionSearchTermInput {
}
__decorate([
    IsString({ each: true }),
    IsOptional()
], ConditionSearchTermInput.prototype, "equalsOneOf", void 0);
__decorate([
    IsString({ each: true }),
    IsOptional()
], ConditionSearchTermInput.prototype, "childrenOf", void 0);
__decorate([
    IsString({ each: true }),
    IsOptional()
], ConditionSearchTermInput.prototype, "excludeChildrenOf", void 0);
__decorate([
    IsString(),
    IsOptional()
], ConditionSearchTermInput.prototype, "withinWeeks", void 0);
export class MedicationSearchTermInput {
}
__decorate([
    IsString({ each: true })
], MedicationSearchTermInput.prototype, "medicationCodeEquals", void 0);
__decorate([
    IsString({ each: true }),
    IsOptional()
], MedicationSearchTermInput.prototype, "withinWeeks", void 0);
export class ObservationSearchTermInput {
}
__decorate([
    IsString()
], ObservationSearchTermInput.prototype, "obEquals", void 0);
__decorate([
    IsString({ each: true }),
    IsOptional()
], ObservationSearchTermInput.prototype, "valueEqualsOneOf", void 0);
__decorate([
    IsString(),
    IsOptional()
], ObservationSearchTermInput.prototype, "valueLessThanOrEqual", void 0);
__decorate([
    IsString(),
    IsOptional()
], ObservationSearchTermInput.prototype, "valueGreaterThanOrEqual", void 0);
__decorate([
    IsString(),
    IsOptional()
], ObservationSearchTermInput.prototype, "unit", void 0);
__decorate([
    IsString(),
    IsOptional()
], ObservationSearchTermInput.prototype, "withinWeeks", void 0);
export class BaseSearchCriteria {
}
__decorate([
    Type(() => BasicSearchTermInput),
    ValidateNested(),
    IsOptional()
], BaseSearchCriteria.prototype, "gender", void 0);
__decorate([
    Type(() => ComparableSearchTermInput),
    ValidateNested(),
    IsOptional()
], BaseSearchCriteria.prototype, "age", void 0);
__decorate([
    Type(() => LocationSearchTermInput),
    ValidateNested(),
    IsOptional()
], BaseSearchCriteria.prototype, "zip", void 0);
__decorate([
    Type(() => BasicSearchTermInput),
    ValidateNested(),
    IsOptional()
], BaseSearchCriteria.prototype, "race", void 0);
__decorate([
    Type(() => BasicSearchTermInput),
    ValidateNested(),
    IsOptional()
], BaseSearchCriteria.prototype, "ethnicity", void 0);
__decorate([
    Type(() => ConditionSearchTermInput),
    ValidateNested(),
    IsOptional()
], BaseSearchCriteria.prototype, "condition", void 0);
__decorate([
    Type(() => ObservationSearchTermInput),
    ValidateNested(),
    IsOptional()
], BaseSearchCriteria.prototype, "lab", void 0);
__decorate([
    Type(() => ObservationSearchTermInput),
    ValidateNested(),
    IsOptional()
], BaseSearchCriteria.prototype, "vital", void 0);
__decorate([
    Type(() => MedicationSearchTermInput),
    ValidateNested(),
    IsOptional()
], BaseSearchCriteria.prototype, "medication", void 0);
export class ClassicSearchInput extends BaseSearchCriteria {
}
export class SearchCriteria extends BaseSearchCriteria {
}
__decorate([
    Type(() => SearchCriteria),
    ValidateNested({ each: true }),
    IsOptional()
], SearchCriteria.prototype, "nestedCriteria", void 0);
__decorate([
    IsBoolean()
], SearchCriteria.prototype, "negate", void 0);
__decorate([
    IsString(),
    IsOptional()
], SearchCriteria.prototype, "operator", void 0);
export class SearchInput {
}
__decorate([
    IsString({ each: true })
], SearchInput.prototype, "mrns", void 0);
__decorate([
    Type(() => SearchCriteria),
    ValidateNested({ each: true })
], SearchInput.prototype, "criteria", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], SearchInput.prototype, "limit", void 0);
__decorate([
    Type(() => ConsentStateSearchInput),
    ValidateNested({ each: true }),
    IsOptional()
], SearchInput.prototype, "consentState", void 0);
export class SearchByMRNInput {
}
__decorate([
    IsString()
], SearchByMRNInput.prototype, "mrn", void 0);
__decorate([
    IsString(),
    IsOptional()
], SearchByMRNInput.prototype, "studyId", void 0);
__decorate([
    Type(() => ConsentRequestSearchInput),
    ValidateNested(),
    IsOptional()
], SearchByMRNInput.prototype, "consentRequestSearchInput", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], SearchByMRNInput.prototype, "start", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], SearchByMRNInput.prototype, "end", void 0);
export class SearchByMRNInputWithoutConsents {
}
__decorate([
    IsString()
], SearchByMRNInputWithoutConsents.prototype, "mrn", void 0);
__decorate([
    IsString(),
    IsOptional()
], SearchByMRNInputWithoutConsents.prototype, "projectId", void 0);
export class SearchByPatientHealthExIdInput {
}
__decorate([
    IsString()
], SearchByPatientHealthExIdInput.prototype, "patientHealthExId", void 0);
export class RelatedMedicationSearchInput {
}
__decorate([
    IsString({ each: true })
], RelatedMedicationSearchInput.prototype, "medicationCodes", void 0);
export class AgentSearchInput {
}
__decorate([
    IsString({ each: true }),
    IsOptional()
], AgentSearchInput.prototype, "mrns", void 0);
__decorate([
    Type(() => SearchCriteria),
    ValidateNested({ each: true }),
    IsOptional()
], AgentSearchInput.prototype, "criteria", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], AgentSearchInput.prototype, "limit", void 0);
__decorate([
    Type(() => ConsentStateSearchInput),
    ValidateNested({ each: true }),
    IsOptional()
], AgentSearchInput.prototype, "consentState", void 0);
export class SearchResultsSummary {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsObject(),
    IsOptional()
], SearchResultsSummary.prototype, "gender", void 0);
__decorate([
    IsObject(),
    IsOptional()
], SearchResultsSummary.prototype, "age", void 0);
__decorate([
    IsObject(),
    IsOptional()
], SearchResultsSummary.prototype, "zip", void 0);
__decorate([
    IsObject(),
    IsOptional()
], SearchResultsSummary.prototype, "race", void 0);
__decorate([
    IsObject(),
    IsOptional()
], SearchResultsSummary.prototype, "ethnicity", void 0);
__decorate([
    IsObject(),
    IsOptional()
], SearchResultsSummary.prototype, "conditions", void 0);
export class SearchResults {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => GlobalPatientReference),
    ValidateNested({ each: true })
], SearchResults.prototype, "matches", void 0);
__decorate([
    Type(() => SearchResultsSummary),
    ValidateNested(),
    IsOptional()
], SearchResults.prototype, "summary", void 0);
export class SearchByMRNPatientResults {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => PatientGuidedConsentDto),
    IsOptional(),
    ValidateNested()
], SearchByMRNPatientResults.prototype, "patient", void 0);
__decorate([
    Type(() => PatientConsentsByStudyDto),
    ValidateNested({ each: true })
], SearchByMRNPatientResults.prototype, "consents", void 0);
export class SearchByMRNPatientResultsWithoutConsents {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsNumber()
], SearchByMRNPatientResultsWithoutConsents.prototype, "totalProcessed", void 0);
__decorate([
    IsNumber()
], SearchByMRNPatientResultsWithoutConsents.prototype, "successCount", void 0);
__decorate([
    IsNumber()
], SearchByMRNPatientResultsWithoutConsents.prototype, "errorCount", void 0);
__decorate([
    IsNumber()
], SearchByMRNPatientResultsWithoutConsents.prototype, "duplicatesCount", void 0);
__decorate([
    IsOptional(),
    Type(() => Object)
], SearchByMRNPatientResultsWithoutConsents.prototype, "errors", void 0);
__decorate([
    IsOptional(),
    Type(() => Object)
], SearchByMRNPatientResultsWithoutConsents.prototype, "duplicates", void 0);
__decorate([
    IsOptional(),
    Type(() => Object)
], SearchByMRNPatientResultsWithoutConsents.prototype, "successfulPatients", void 0);
export class SearchByMRNIdentifiedPatientResults {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => StudyDto),
    IsOptional(),
    ValidateNested()
], SearchByMRNIdentifiedPatientResults.prototype, "study", void 0);
__decorate([
    Type(() => PatientGuidedConsentDto),
    IsOptional(),
    ValidateNested()
], SearchByMRNIdentifiedPatientResults.prototype, "patient", void 0);
__decorate([
    Type(() => IdentifiedPatientDto),
    IsOptional()
], SearchByMRNIdentifiedPatientResults.prototype, "identifiedPatient", void 0);
__decorate([
    Type(() => ConsentFlowProgressDto),
    ValidateNested({ each: true })
], SearchByMRNIdentifiedPatientResults.prototype, "consentFlowProgress", void 0);
export class AgentSearchResults {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => SearchResultsSummary)
], AgentSearchResults.prototype, "summary", void 0);
export class AgentSearchByMRNResult {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    IsOptional()
], AgentSearchByMRNResult.prototype, "healthExPatientId", void 0);
export class AgentSearchResultsSummary {
}
